import { EventShowtimePickerIdsType, EventShowtimePickerPropsFromBe } from '../../types'
import { getEventSiteIds, getEvents, getSites } from '../../utils'
import { useEffect, useState } from 'react'

import { CreateEventShowtimePickerProps } from './props'
import { Dropdown } from '@vista/omnichannel-components-ui'
import { EventShowtimePickerComponent as OccEventShowtimePickerComponent } from '@vista/omnichannel-components-ui'
import React from 'react'

export const EventShowtimePickerComponent: React.FC<EventShowtimePickerPropsFromBe> = props => {
    const { siteDropdownMode } = props
    const [optionsList, setOptionList] = useState([])

    const isVenuesPage = window.location.pathname.includes('/venues/')

    useEffect(() => {
        if (!siteDropdownMode) {
            getEvents().then(events => {
                if (optionsList.length < 2) {
                    setOptionList(events)
                }
            })
        } else {
            getSites().then(sites => {
                getEventSiteIds(props.workflow.entityIds.eventId).then(siteIds => {
                    if (optionsList.length < 2) {
                        const filteredSites = sites.filter(s => siteIds.includes(s.value))
                        setOptionList(filteredSites)
                    }
                })
            })
        }
    }, [])

    const options = optionsList

    const [option, setOption] = useState(options[0]?.value || null)

    const showtimePickerIds: EventShowtimePickerIdsType = {
        eventId: !siteDropdownMode ? option : props.workflow.entityIds.eventId,
        siteId: !siteDropdownMode ? props.workflow.entityIds.siteId : option,
    }

    const eventShowtimePickerProps = CreateEventShowtimePickerProps(props, showtimePickerIds) 

    return (
        <>
            {options.length > 0 && (
                <div className="event-showtime-picker">
                    <div className="event-showtime-picker__dropdown-wrapper">
                        <Dropdown
                            options={options}
                            value={option}
                            placeholder={isVenuesPage?'Select an Option':'Select a venue'}
                            onChangeValue={setOption}
                            buttonIconName='chevron-down'
                        />
                    </div>

                    {option && <OccEventShowtimePickerComponent {...eventShowtimePickerProps} />}

                    {!option && siteDropdownMode && (
                        <div className="v-message">
                            <svg className="v-icon v-icon--curzon-pin v-message__icon"><use xlinkHref={"#v-icon_no-site-selected"}></use></svg>
                            <h2 className="v-message__title">
                                {eventShowtimePickerProps.displayText.noSitesSelectedTitle}
                            </h2>
                            <div className="v-message__description">
                                {eventShowtimePickerProps.displayText.noSitesSelectedMessage}
                            </div>
                        </div>
                    )}

                    {!option && !siteDropdownMode && (
                        <div className="v-message">
                            <svg className="v-icon v-icon--curzon-calendar v-message__icon"><use xlinkHref={"#v-icon_calendar"}></use></svg>
                            <h2 className="v-message__title">
                                {eventShowtimePickerProps.displayText.noSitesSelectedTitle}
                            </h2>
                            <div className="v-message__description">
                                {eventShowtimePickerProps.displayText.noSitesSelectedMessage}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default EventShowtimePickerComponent